import { normalizeRequest, analyzeMetrics, formatAnalysis, ANALYSIS_VERSION } from './analytics.mjs';
import { countryEntity } from './entities.mjs';

export { ANALYSIS_VERSION };
function formatWithEntities(input) {
  const result = formatAnalysis(analyzeMetrics(input));
  result.issueDetails = result.issueDetails.map(issue => {
    const match = /^segment_(?:drop_)?(\d+)$/.exec(issue.id);
    const segment = match ? input.current.segments[Number(match[1])] : null;
    const entity = segment?.kind === 'country' ? countryEntity(segment.label) : null;
    return { ...issue, ...(entity ? { entity } : {}), ...(segment ? { subject: { kind: segment.kind, label: entity?.label || segment.label } } : {}) };
  });
  return result;
}

// Pure browser module: no network, React, storage or server dependencies.
export function analyzeOverview(body, now = Date.now()) {
  return formatWithEntities(normalizeRequest(body, now));
}

// Cached GPT must be compared against the source snapshot it actually analyzed.
export function analyzeOverviewSnapshot(snapshot, body, now = Date.now()) {
  const expected = normalizeRequest(body, now);
  const selection = input => ({
    version: input.version, projectId: input.projectId, scope: input.scope,
    period: input.period, previous: input.previous?.period ?? null,
  });
  if (!snapshot || JSON.stringify(selection(snapshot)) !== JSON.stringify(selection(expected))) throw new Error('ANALYSIS_SNAPSHOT_MISMATCH');
  return formatWithEntities(snapshot);
}
